export const COLOR_PICKER = {
    MODAL: "color-picker-modal",
    SUBMIT: "color-picker-submit",
};
